import { useTranslation } from 'next-i18next'

import bootcampAnalytics from '~/analytics/bootcamp/bootcampAnalytics'

import { CATEGORY_COLORS } from '~/bootcamp/constants/bootcamp.const'
import Button from '~/components/Buttons/Button'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { MediaQueryType } from '~/components/Image/types'
import { TopicId } from '~/dashboard/utils/learningPath.utils'

const queries: MediaQueryType[] = [
  { screen: '(max-width: 767px)', width: '240px' },
  { screen: '(min-width: 768px)', width: '360px' },
]

export default function TopicSelector({
  topic,
  path,
}: {
  topic: { iconKey: string; key: TopicId; href: string; iconAlt: string }
  path: string
}): React.ReactElement {
  const { t } = useTranslation(['onboarding', 'generics'])

  const onTopicClick = (): void => {
    bootcampAnalytics.logSelectTopic(topic.key)
  }
  const colorClassName = `${CATEGORY_COLORS[topic.key].gradientClass} ${CATEGORY_COLORS[topic.key].shadowClass}`
  const title = topic.key
    .split('-')
    .map((word, i) => (i !== 0 ? word.charAt(0).toLocaleUpperCase() + word.slice(1) : word))
    .join('')

  return (
    <Button
      className={`flex flex-col justify-between items-center w-35 md:w-46 self-stretch py-2 sm:py-4 my-2 lg:hover:scale-110 cursor-pointer duration-300 border border-white rounded ${colorClassName}`}
      href={path}
      onClick={() => {
        onTopicClick()
      }}
    >
      <div className="flex justify-center py-1 my-auto w-full">
        <h1 className="text-sm md:text-lg font-semibold text-center w-full text-white px-1">
          {t(`onboarding:${title}`)}
        </h1>
      </div>
      <div
        className={`flex items-end h-1/2 pb-2 ${
          topic.key === TopicId.ALGEBRA ? '-ml-4 md:-ml-6' : topic.key !== TopicId.FUNCTIONS ? '-ml-6' : ''
        }`}
      >
        <ResponsiveImage
          alt={topic.iconAlt}
          fit="contain"
          height={topic.key === TopicId.ALGEBRA ? 140 : 120}
          imageClassName={
            topic.key === TopicId.GEOMETRY
              ? 'w-18 md:w-28'
              : topic.key === TopicId.ALGEBRA
              ? '-mb-2 w-20 md:w-30'
              : 'w-20 md:w-30 '
          }
          imageWidths="240, 360"
          mediaQuery={queries}
          srcKey={topic.iconKey}
          width={150}
        />
      </div>
      <div className="bg-purple border border-white text-white rounded py-0.5 px-4">{t('generics:go')}</div>
    </Button>
  )
}
